import StyledForm from "../../UI/StyledForm";
import {
  CalendarCheck,
  DocumentIcon,
  TypeBail,
  ZoneTendue,
} from "../../UI/Icons";
import TextInput from "../../UI/TextInput";
import Checkbox from "../../UI/Checkbox";
import Select, { ReactSelect } from "../../UI/Select";
import Callout from "../../UI/Callout";
import Text from "../../UI/Text";
import FieldArrayAutreCharge from "../FieldArrayAutreCharge";
import { useFormikContext } from "formik";
import { PaymentType } from "../../../models/tenant_old.js";
import { TVA_RATES } from "../../../utils/constants/compta";
import { ChargesType, TenantLeaseType } from "../../../utils/constants/tenants";
import RadioGroup from "../../UI/RadioGroup";
import Radio from "../../UI/Radio";
import Accordion, { AccordionItem } from "../../UI/Accordion";
import { INDEX_TYPE_LABELS } from "../../../models/property";
import styles from "./TenantLeaseForm.module.css";

export default function TenantLeaseForm({
  leaseType,
  propertyType,
  allowChargesForfait = false,
}) {
  const { values, setFieldValue, handleChange } = useFormikContext();
  return (
    <>
      <StyledForm
        formElement={<TextInput type="date" name={"debut"} />}
        label="Date de début du bail"
        icon={<CalendarCheck stroke={"#9D9D9D"} />}
        mandatory
      />
      <StyledForm
        formElement={
          <>
            <TextInput type="date" name={"fin"} />
            <Checkbox className={"marginB10"} name={"preavis"}>
              Préavis déposé
            </Checkbox>
          </>
        }
        label="Date d'échéance du bail"
        icon={<CalendarCheck stroke={"#9D9D9D"} />}
        mandatory
      />
      <StyledForm
        formElement={
          <>
            <TextInput
              type="number"
              name="loyer_hc"
              placeholder="Loyer hors charge"
              step={"0.01"}
            />
            <Checkbox
              className={"marginB10"}
              name={"tva"}
              onChange={(e) => {
                handleChange(e);
                if (!e.target.checked) {
                  setFieldValue("taux_tva", "");
                }
              }}
            >
              locataire assujetti à la TVA
            </Checkbox>
            {values.tva && (
              <ReactSelect
                name="taux_tva"
                label="Taux de TVA"
                mandatory
                options={TVA_RATES}
                className={"marginB10"}
              />
            )}
            <FieldArrayAutreCharge />
            {TenantLeaseType.isHabitation(leaseType) &&
              propertyType !== "commercial" && (
                <TextInput
                  type="number"
                  label={"Si la CAF vous paye directement, indiquez le montant"}
                  name="montant_caf"
                  placeholder="243"
                  step={"0.01"}
                />
              )}
          </>
        }
        label={
          TenantLeaseType.isCommercial(leaseType)
            ? "Loyer HT"
            : "Loyer hors charge (mais avec complément de loyer, le cas échéant)"
        }
        icon={<ZoneTendue />}
        mandatory
      />
      <StyledForm
        formElement={
          <>
            <TextInput
              type="number"
              name="charges"
              placeholder="Charges"
              step={"0.01"}
            />
            {allowChargesForfait && (
              <RadioGroup marginForm={styles.chargeTypeGroup}>
                <Radio
                  name="type_charge"
                  value={ChargesType.PROVISION}
                  label="Provision sur charge"
                />
                <Radio
                  name="type_charge"
                  value={ChargesType.FORFAIT}
                  label="Forfait de charge"
                />
              </RadioGroup>
            )}
            <Checkbox
              name={"tva_charge"}
              className={"marginB10"}
              onChange={(e) => {
                handleChange(e);
                if (!e.target.checked) {
                  setFieldValue("taux_tva_charge", "");
                }
              }}
            >
              Les charges sont soumises à la TVA
            </Checkbox>
            {values.tva_charge && (
              <ReactSelect
                name="taux_tva_charge"
                label="Taux de TVA sur les charges"
                mandatory
                options={TVA_RATES}
                className={"marginB10"}
              />
            )}
          </>
        }
        label="Charges"
        icon={<ZoneTendue />}
        mandatory
      />

      <StyledForm
        formElement={
          <TextInput
            type="number"
            name="deposit"
            placeholder="Montant du dépôt de garantie"
            step={"0.01"}
          />
        }
        label="Montant du dépôt de garantie"
        icon={<ZoneTendue />}
        mandatory
      />

      <StyledForm
        formElement={
          <div className={"flex wrap gap10"}>
            <TextInput
              type="number"
              name="day_payment"
              placeholder="Jour du mois auquel le loyer doit être payé"
            />
            <Select name="payment_recurrence" className={""}>
              <option value="1">Mensuel</option>
              <option value="3">Trimestriel</option>
              <option value="6">Semestriel</option>
              <option value="12">Annuel</option>
            </Select>
            {String(values.payment_recurrence) !== "1" && (
              <Checkbox
                name={"payment_periods_from_start_date"}
                className={styles.periodCheckbox}
              >
                Périodes calées sur le mois de début du bail plutôt que sur
                l'année civile (ex. : bail trimestriel débutant le 12/12 : du
                12/12 au 28/02, puis du 01/03 au 31/05)
              </Checkbox>
            )}
          </div>
        }
        label="Jour du mois auquel le loyer doit être payé"
        icon={<CalendarCheck />}
        mandatory
      />

      <StyledForm
        formElement={<TextInput type="date" name="last_revision_date" />}
        label="Date de la dernière révision de loyer"
        icon={<CalendarCheck />}
      />

      <StyledForm
        formElement={<TextInput type="date" name="date_signature" />}
        label="Date de signature du bail"
        icon={<TypeBail />}
        mandatory
      />

      <StyledForm
        formElement={
          <div className={styles.indexBlock}>
            <RadioGroup marginForm="">
              {Object.keys(INDEX_TYPE_LABELS).map((value) => (
                <Radio
                  key={value}
                  name="type_irl"
                  value={value}
                  label={value}
                />
              ))}
            </RadioGroup>
            <div className={styles.indexFields}>
              <TextInput type="text" name="irl_trimestre" label={"Trimestre"} />
              <TextInput type="number" name="irl_annee" label={"Année"} />
              <TextInput
                type="number"
                name="irl_indice"
                label={"Indice"}
                step={"0.01"}
              />
            </div>
          </div>
        }
        label="Indice de révision du loyer"
        moreText={
          <Text variant="deci">
            {INDEX_TYPE_LABELS[values.type_irl]
              ? `${INDEX_TYPE_LABELS[values.type_irl]}. `
              : ""}
            Si vous changez d'indice, mettez à jour le trimestre, l'année et la
            valeur de référence.
          </Text>
        }
        icon={<TypeBail />}
      />
      {TenantLeaseType.isCommercial(leaseType) && (
        <StyledForm
          formElement={
            <Checkbox name={"is_triennal"} className={"marginB10"}>
              Révision triennale
            </Checkbox>
          }
          label="Type de révision"
          icon={<TypeBail />}
        />
      )}

      {values.type_paiement === PaymentType.PRELEVEMENT && (
        <StyledForm
          formElement={
            <Checkbox name={"is_first_prelevement"} className={"marginB10"}>
              Il s'agit du premier prélèvement
            </Checkbox>
          }
          label="Prélèvement"
          icon={<TypeBail />}
        />
      )}

      <StyledForm
        formElement={
          <RadioGroup>
            <Radio name="is_type_quittance" value="true" label="Quittance" />
            <Radio name="is_type_quittance" value="false" label="Facture" />
          </RadioGroup>
        }
        label="Type de document pour ce locataire"
        icon={<DocumentIcon />}
      />

      <StyledForm
        formElement={
          <Checkbox name="is_indemnite_occupation">
            Locataire sans droit ni titre : générer des indemnités d'occupation
            à la place du loyer
          </Checkbox>
        }
        label="Indemnité d'occupation"
        icon={<DocumentIcon />}
      />

      <StyledForm
        formElement={
          <TextInput
            type="text"
            name="echeance_paiement"
            placeholder="Ex : 30 jours à réception"
          />
        }
        label="Échéance de paiement (optionnel, si vide utilise la valeur par défaut du profil bailleur)"
        icon={<CalendarCheck />}
      />

      <Accordion className={styles.advanced}>
        <AccordionItem title="Avancé" variant="plain">
          <StyledForm
            formElement={
              <div className={styles.accountRow}>
                <TextInput
                  type="text"
                  name="customer_account_number"
                  label="Compte client"
                  placeholder="41100001"
                />
                <TextInput
                  type="text"
                  name="deposit_account_number"
                  label="Compte de dépôt de garantie"
                  placeholder="16500001"
                />
              </div>
            }
            label="Comptes du bail dans votre comptabilité (export FEC)"
            moreText={
              <Text variant="deci">
                Un compte effacé est réattribué automatiquement à la suite du
                dernier numéro utilisé sur le profil bailleur.
              </Text>
            }
            icon={<DocumentIcon />}
          />
        </AccordionItem>
      </Accordion>

      <Callout variant="warning" className={styles.footerCallout}>
        <Text as="p">
          Les informations modifiées ici ne sont pas répercutées dans le bail
          généré. Pour modifier le bail, vous devez aller dans l'onglet "Action
          / courrier" du locataire, puis cliquer sur "Regénérer le bail".
        </Text>
        <Text as="p">
          Si vous avez modifié les dates d'entrée ou de sortie, rendez-vous dans
          l'onglet "historique des paiements" pour mettre à jour les prorata de
          début et/ou de fin.
        </Text>
      </Callout>
    </>
  );
}
